import useHttp from "./useHttp";
export default function useUsers() {
  const { fetchData } = useHttp();

  const fetchCurrentUsers = (appProperties) => {
    return new Promise((resolve, reject) => {
      const osyncId = appProperties.osyncId;
      const leftServiceId = appProperties.leftServiceId;

      if (appProperties !== undefined) {
        fetchData("omni/license?leftServiceId=" + leftServiceId + "&osyncId=" + osyncId, "GET", null, appProperties).then((response) => {
          if (response) {
            let responseData = JSON.parse(response);
            let savedUsers = responseData.data;
            resolve(savedUsers);
          }
        });
      }
    });
  };

  const fetchUsers = (appProperties) => {
    return new Promise((resolve, reject) => {
      let integId = appProperties.randomIntegId;
      const leftServiceId = appProperties.leftServiceId;

      if (appProperties !== undefined) {
        fetchData("omni/userLicense/agents?leftServiceId=" + leftServiceId + "&integId=" + integId, "GET", null, appProperties).then(
          (response) => {
            if (response) {
              let responseData = JSON.parse(response);
              let savedUsers = responseData.data;
              resolve(savedUsers);
            }
          }
        );
      } else {
        resolve([]);
      }
    });
  };

  const addUsers = (appProperties, body, url, urlMethod) => {
    return new Promise((resolve, reject) => {
      if (appProperties !== undefined) {
        fetchData(`omni/userLicense/` + url, urlMethod, body, appProperties).then((response) => {
          if (response) {
            let responseData = JSON.parse(response);
            resolve(responseData);
          } else {
            resolve(false);
          }
        });
      }
    });
  };

  const checkUserDeleteEligibility = (appProperties, osyncUserId) => {
      return new Promise((resolve, reject) => {
          if (!appProperties?.osyncId || !osyncUserId) {
              resolve({ requiresMigration: false });
              return;
          }
          let url = `omni/userLicense/deletion/preview?osyncUserId=${encodeURIComponent(osyncUserId)}`;
          if (appProperties?.leftServiceId) {
              url += `&leftServiceId=${encodeURIComponent(appProperties.leftServiceId)}`;
          }
          fetchData(url, "GET", null, appProperties)
              .then((response) => {
                  if (response) {
                      const parsed = JSON.parse(response);
                      resolve(parsed?.data || { requiresMigration: false });
                  } else {
                      resolve({ requiresMigration: true });
                  }
              })
              .catch(() => resolve({ requiresMigration: true }));
      });
  };

  const deleteUser = (appProperties, body) => {
    return new Promise((resolve, reject) => {
      if (appProperties !== undefined) {
        fetchData(`omni/userLicense/delete`, "DELETE", body, appProperties).then((response) => {
          if (response) {
            let responseData = JSON.parse(response);
            resolve(responseData);
          }
        });
      }
    });
  };

  const getUserAccountDetails = (companyId, userId, leftServiceId, controller, appPropsObject) => {
    return new Promise((resolve, reject) => {
      if (companyId && userId && leftServiceId) {
        if (companyId) {
          companyId = encodeURIComponent(companyId);
        }
        const dependencies = {
          companyId: companyId,
          userId: userId,
          leftServiceId: leftServiceId,
        };
        fetchData(
          `account/fetcher?companyId=${companyId}&userId=${userId}&leftServiceId=${leftServiceId}`,
          "GET",
          null,
          appPropsObject,
          null,
          dependencies
        ).then((response) => {
          if (response) {
            if (response?.accountDetails) {
              resolve(response);
            }
            let responseData = JSON.parse(response);
            resolve(responseData);
          }
        });
      }
    });
  };

  const assignUserForContact = (contactId, contactOwnerEntityId, appProperties) => {
    return new Promise((resolve, reject) => {
      if (appProperties && contactId && contactOwnerEntityId) {
        fetchData(`omessage/conversation/${contactId}/assign`, "POST", { contactOwnerEntityId }, appProperties).then((response) => {
          const responseDataJson = JSON.parse(response)?.data;
          if (responseDataJson?.success && responseDataJson?.data?.messages) {
            resolve(responseDataJson?.data?.messages);
          } else {
            reject(responseDataJson?.errorMessage);
          }
        });
      }
    });
  };

  return {
      fetchUsers,
      addUsers,
      deleteUser,
      checkUserDeleteEligibility,
      fetchCurrentUsers,
      getUserAccountDetails,
      assignUserForContact,
  };
}
